export default "__VITE_ASSET__BhNKtxjH__"